module.exports = __webpack_public_path__ + "onboarding-success.8b9e5b3aa3d702006ed6808cb22e148e.hashedasset.svg";